import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "v2_suite_case",
  "use": "v2_suite_case-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"v2_suite_case\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M1 1h18v18H1z\" />\n        <path fill=\"#D4D4D4\" d=\"M15.77 6.032h-3.06V4.516c0-.841-.68-1.516-1.53-1.516H8.12c-.85 0-1.53.675-1.53 1.516v1.516H3.53c-.85 0-1.522.674-1.522 1.515L2 15.884c0 .841.68 1.516 1.53 1.516h12.24c.85 0 1.53-.675 1.53-1.516V7.547c0-.84-.68-1.515-1.53-1.515zM17.3 8v1H2V8h15.3zm-6.12-3.484v1.516H8.12V4.516h3.06z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol